import { render } from "./WhatSection.vue?vue&type=template&id=cad01460&scoped=true"
import script from "./WhatSection.vue?vue&type=script&lang=js"
export * from "./WhatSection.vue?vue&type=script&lang=js"

import "./WhatSection.vue?vue&type=style&index=0&id=cad01460&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cad01460"]])

export default __exports__